import PDEV_QSet from './roleQuestionSets/PDEV_QuestionSet';
import PM_QSet from './roleQuestionSets/PM_QuestionSet';
import OPS_QSet from './roleQuestionSets/OPS_QuestionSet';
// import TEST8_QSet from './roleQuestionSets/TEST8_QuestionSet';
import None from './roleQuestionSets/None';

const QuestionSets = {
    'Choose your role': None,
    'Product Development Leader': PDEV_QSet,
    'Product Management Leader': PM_QSet,
    'Head of Operations': OPS_QSet,
};       

export default QuestionSets;
